(() => {
  const LABEL_SELECTOR = '[data-garan-label]';

  function parseOfficialSvg(source) {
    const documentNode = new DOMParser().parseFromString(source, 'image/svg+xml');
    if (documentNode.querySelector('parsererror')) return null;
    return documentNode.documentElement?.nodeName.toLowerCase() === 'svg'
      ? documentNode.documentElement
      : null;
  }

  function uniqueTextNode(svg, expectedText, expectedClass) {
    const matches = [...svg.querySelectorAll('text')].filter(
      (node) => node.textContent.trim() === expectedText && (!expectedClass || node.classList.contains(expectedClass)),
    );
    return matches.length === 1 ? matches[0] : null;
  }

  function buildFullLabel(source, { years, guarantor, model }) {
    const svg = parseOfficialSvg(source);
    if (!svg) return null;

    const yearsNode = uniqueTextNode(svg, 'XX', 'cls-3');
    const guarantorNode = uniqueTextNode(svg, 'Brand/Trademark', 'cls-5');
    const modelNode = uniqueTextNode(svg, 'Model identifier', 'cls-5');
    if (!yearsNode || !guarantorNode || !modelNode) return null;

    yearsNode.textContent = years;
    guarantorNode.textContent = guarantor;
    modelNode.textContent = model;
    svg.setAttribute('aria-hidden', 'true');
    return svg;
  }

  async function hydrateLabel(label) {
    if (label.dataset.garanHydrated || label.dataset.garanHydrating) return;
    label.dataset.garanHydrating = 'true';

    const years = label.dataset.garanYears;
    const guarantor = label.dataset.garanGuarantor;
    const model = label.dataset.garanModel;
    const fullUrl = label.dataset.garanFullSrc;

    try {
      const fullResponse = await fetch(fullUrl);
      if (!fullResponse.ok) return;

      const fullSource = await fullResponse.text();
      const fullSvg = buildFullLabel(fullSource, { years, guarantor, model });
      if (!fullSvg) return;

      label.querySelector('[data-garan-full-svg]')?.replaceChildren(fullSvg);
      label.dataset.garanHydrated = 'true';
      label.hidden = false;
    } catch {
      label.dataset.garanHydrationFailed = 'true';
    } finally {
      delete label.dataset.garanHydrating;
    }
  }

  function hydrateAll(root = document) {
    if (root.matches?.(LABEL_SELECTOR)) hydrateLabel(root);
    root.querySelectorAll?.(LABEL_SELECTOR).forEach(hydrateLabel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrateAll(), { once: true });
  } else {
    hydrateAll();
  }

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) hydrateAll(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
